// ./contect/initialstate.js

// export default {
//     isLoggedIn : false,
//     authData: {
//         email:'test@gmail.com',
//         name: 'Test',
//         photo: 'https://www.psdgraphics.com/file/user-icon.jpg',
//         role: 'admin'
//     },
// }

// ./context/initialStates/authInitialState.js

const loadAuthFromStorage = () => {
  try {
    const userInfoStr = localStorage.getItem('userInfo');
    const userRole = localStorage.getItem('userRole');

    if (userInfoStr) {
      const userInfo = JSON.parse(userInfoStr);
      return {
        isLoggedIn: true,
        authData: {
          email: userInfo.email,
          id: userInfo.id || userInfo.sub,
          name: userInfo.name,
          photo: userInfo.photo || userInfo.picture,
          role: (userRole || userInfo.role || 'student').toLowerCase()
        }
      };
    }
  } catch (err) {
    console.error('❌ Failed to load auth from storage:', err);
  }

  // Not logged in
  return {
    isLoggedIn: false,
    authData: {}
  };
};

export default loadAuthFromStorage();